import { Component, ElementRef, input, ViewChild } from '@angular/core';

@Component({
  selector: 'ctr-content',
  imports: [],
  templateUrl: './content.component.html',
  styleUrl: './content.component.scss',
})
export class ContentComponent {
  @ViewChild('footerParent') footerContent?: ElementRef<HTMLElement>;
  type = input<'page' | 'form'>('page');

  get maxSize() {
    return this.type() === 'page' ? '1280px' : '980px';
  }
}
